import { render, staticRenderFns } from "./iconText.vue?vue&type=template&id=e8a17daa&scoped=true&"
import script from "./iconText.vue?vue&type=script&lang=ts&"
export * from "./iconText.vue?vue&type=script&lang=ts&"
import style0 from "./iconText.vue?vue&type=style&index=0&id=e8a17daa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a17daa",
  null
  
)

export default component.exports